export const LANDING_PAGE_LINK = "https://www.onbento.com/";
export const BRAND_LANDING_PAGE_LINK = "https://www.onbento.com/brands";
export const BENTO_RESOURCES_GUIDE_LINK =
  "https://hatchways.notion.site/Bento-Resource-Guide-b43c00e8980347fca5de92cd71c51818";
export const UNSPECIFIED = "unspecifed";
export const TERMS_AND_CONDITIONS_LINK_MONTHLY =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Bento%E2%80%99s%20Virtual%20Assistant%20Monthly%20Program%20Agreement%20-%20Oct_17_updated.pdf";
export const TERMS_AND_CONDITIONS_LINK_YEARLY =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Bento%E2%80%99s%20Virtual%20Assistant%20Program%20Agreement%20-%20July%2025%20Update.pdf";
export const BENTO_VA_ONBOARDING_CALENDLY_LINK =
  "https://calendly.com/jaclyn-bento/virtual-assistant-onboarding";
export const CLOSE_VA_ANNOUNCEMENT = "close_va_announcement";
export const VA_LANDING_PAGE_LINK = "https://www.onbento.com/va";
export const PARTNERSHIP_DATA_EXAMPLE =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/partnership_data.png";
export const COMMISSION_PERCENTAGE = 10;
export const AFFILIATE_TERMS_AND_CONDITIONS_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Bento's%20Affiliate%20Terms%20%26%20Conditions%20-%20September%202025.pdf";
export const AFFILIATE_CONTENT_FORM =
  "https://docs.google.com/forms/d/e/1FAIpQLScA75j4KjVTL-SDorbW5vPA5bkxVPEK15R2DIEvOyKJVpwmsg/viewform";
export const VA_SUBSCRIPTION_LOOM_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/make_the_most_of_va_tier.mp4";
export const WELCOME_LINK =
  "https://www.loom.com/embed/4ae5d29e373a42269dfc846e99e5939d?sid=f5530923-de06-4bf2-bd00-d28f916ac589&hideEmbedTopBar=true";
export const FAIR_PAY_TERMS_AND_CONDITIONS =
  "https://storage.googleapis.com/app-onbento-com/Creator%20Fair%20Pay%20Audit%20%E2%80%94%20Privacy%20Policy%20%26%20Terms.pdf";
export const VA_MONEY_BACK_GUARANTEE =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Updated%20Aug%2029%2C%202025-%20Risk-Free%20Virtual%20Assistant%20Program.pdf";
export const LIVE_COUPON_CODE = "live";
